// @flow
/* eslint-disable import/prefer-default-export */
// $FlowFixMe
import type { UseQueryResult } from '@tanstack/react-query'
import { useMutation } from '@tanstack/react-query'
import type { CreateReminderProps, ReminderProps } from 'types/reminders'

import { QUERIES } from '@/enums/queries'

import { updateReminder } from './services/mutateReminders'
import { invalidateLoadReminders } from './useLoadReminders'

export type UpdateReminderProps = {
  reminder_days?: string,
  reminder_condition?: string,
  enabled?: boolean,
  id: string,
  data: CreateReminderProps,
  isGlobal?: boolean,
}

type Props = {
  updateReminder: (data: UpdateReminderProps) => Promise<void>,
  isLoading: boolean,
} & UseQueryResult<ReminderProps, Error>

export const useUpdateReminders = (options: any = {}): Props => {
  const mutation = useMutation({
    mutationKey: [QUERIES.REMINDERS.UPDATE],
    mutationFn: async ({ id, data, isGlobal }: UpdateReminderProps) =>
      await updateReminder(id, data, isGlobal),
    onSuccess: () => {
      invalidateLoadReminders()
    },
    ...options,
  })

  const updateReminderReq = async ({
    id,
    data,
    isGlobal,
  }: UpdateReminderProps) => {
    return mutation.mutateAsync({ id, data, isGlobal })
  }

  return {
    updateReminder: updateReminderReq,
    ...mutation,
  }
}
